import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { typography, space } from 'styled-system';
import { getThemeColor } from '@bnnvara/helpers';

const StyledThemeTagCard = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme, themeSlug }) => getThemeColor(theme, themeSlug)};
  font-size: 10px;
  font-weight: 700;
  line-height: 10px;

  ${breakpoints.md} {
    border-radius: 2px;
    color: ${({ theme, themeSlug, variant }) =>
      variant === 'default'
        ? theme.base.white
        : getThemeColor(theme, themeSlug)};
    font-size: 12px;
    font-weight: 700;
    line-height: 10px;
  }

  svg {
    height: 14px;
    width: 8px;
    padding-right: 4px;
    * {
      fill: ${({ theme, themeSlug }) => getThemeColor(theme, themeSlug)};
    }
    ${breakpoints.md} {
      width: 4px;
      height: 20px;
      padding-right: 8px;
    }
  }

  ${space}
  ${typography}
  text-transform: ${({ textTransform }) => textTransform};
`;

export const ThemeTagCard = ({
  children,
  themeSlug,
  variant,
  textTransform,
  ...props
}) => {
  return (
    <StyledThemeTagCard
      themeSlug={themeSlug}
      textTransform={textTransform}
      variant={variant}
      {...props}
    >
      <ThemeIcon />
      {children}
    </StyledThemeTagCard>
  );
};

ThemeTagCard.defaultProps = {
  textTransform: 'uppercase',
  variant: 'default',
};

ThemeTagCard.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  themeSlug: PropTypes.string,
  textTransform: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'profile']),
};
